/**
 * PhoneFrame – renders a screenshot inside a stylised phone bezel.
 * Props:
 *   src        – image path
 *   alt        – alt text
 *   glowColor  – CSS colour string for the ambient glow
 *   style      – additional wrapper styles (e.g. animation)
 *   width      – phone width in px (default 200)
 */
export default function PhoneFrame({
  src,
  alt = 'App screenshot',
  glowColor = 'rgba(232,96,74,0.35)',
  style = {},
  width = 200,
}) {
  const radius = Math.round(width * 0.16);

  return (
    <div style={{ position: 'relative', ...style }}>
      <div style={{
        width,
        borderRadius: radius,
        padding: Math.round(width * 0.025),
        background: 'linear-gradient(145deg,#1C3050,#0D1B2A)',
        boxShadow: `0 30px 80px rgba(0,0,0,0.7),
                    0 0 0 1px rgba(255,255,255,0.06),
                    0 0 60px ${glowColor}`,
        position: 'relative',
        overflow: 'hidden',
      }}>
        {/* Top highlight */}
        <div style={{
          position: 'absolute', top: 0, left: 0, right: 0, height: 1,
          background: 'linear-gradient(90deg,transparent,rgba(255,255,255,0.15),transparent)',
        }} />

        {/* Screen */}
        <div style={{ borderRadius: Math.round(radius * 0.85), overflow: 'hidden' }}>
          <img src={src} alt={alt} style={{ width: '100%', display: 'block' }} />
        </div>
      </div>
    </div>
  );
}
